import React from 'react';
import {useIntl} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import DetailsPanel from '../DetailsPanel';
import {TransferRowExtended} from '../TransfersContext';
import icon from '../../../../common/assets/icons/eye.svg';
import {SystemSocialParams} from '../../../../common/types';

export type ButtonDetailsProps = {
  row: TransferRowExtended
  systemSocialParams: SystemSocialParams;
}

const ButtonDetails = ({row, systemSocialParams}: ButtonDetailsProps) => {
  const intl = useIntl();
  const tooltip = intl.formatMessage({
    id: 'transfers-popup-details-tooltip',
    defaultMessage: 'Transfers details'
  });

  const {setPopupPanelContent, openPopupPanel} = useGlobalContext();

  const handleClick = async () => {
    await setPopupPanelContent(<DetailsPanel systemSocialParams={systemSocialParams} {...row} />);
    await openPopupPanel();
  };

  return (
    <ButtonAction
      variant={'icon'}
      icon={icon}
      onClick={handleClick}
      title={tooltip}
    />
  );
};

export default ButtonDetails;
